import { useEffect, useRef, useState } from "react";

import { VIEW_TRANSITION_DURATION } from "../constants";
import { ModalView } from "../types";

export const useModalViewTransition = () => {
  const [modalView, setModalView] = useState<ModalView>("rental-application");
  const [viewTransition, setViewTransition] = useState(false);
  const [previousView, setPreviousView] = useState<ModalView | null>(null);
  const [propertySheetStep, setPropertySheetStep] = useState(1);
  const [tenantSheetStep, setTenantSheetStep] = useState(1);
  const timerRef = useRef<number | null>(null);

  const transitionToPropertyRegistration = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setPreviousView("rental-application");
    setModalView("property-registration");
    setViewTransition(true);
    timerRef.current = window.setTimeout(() => {
      setViewTransition(false);
      setPreviousView(null);
      timerRef.current = null;
    }, VIEW_TRANSITION_DURATION);
  };

  const transitionToTenantRegistration = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setPreviousView("rental-application");
    setModalView("tenant-registration");
    setViewTransition(true);
    timerRef.current = window.setTimeout(() => {
      setViewTransition(false);
      setPreviousView(null);
      timerRef.current = null;
    }, VIEW_TRANSITION_DURATION);
  };

  const transitionBackToRentalApplication = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setPreviousView(modalView);
    setModalView("rental-application");
    setViewTransition(true);
    timerRef.current = window.setTimeout(() => {
      setViewTransition(false);
      setPreviousView(null);
      timerRef.current = null;
    }, VIEW_TRANSITION_DURATION);
  };

  const resetView = () => {
    setModalView("rental-application");
    setViewTransition(false);
    setPreviousView(null);
    setPropertySheetStep(1);
    setTenantSheetStep(1);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return {
    modalView,
    viewTransition,
    previousView,
    propertySheetStep,
    setPropertySheetStep,
    tenantSheetStep,
    setTenantSheetStep,
    transitionToPropertyRegistration,
    transitionToTenantRegistration,
    transitionBackToRentalApplication,
    resetView,
  };
};
